// Image imports
export const images = {
  logoDark: '/logo-dark.png',
  logoDark2: '/logo-dark2.png',
  cargoContainers: '/cargo-containers.jpg',
  countries: {
    somalia: '/Somalia.png',
    yemen: '/Yemen.png',
    oman: '/Oman.png',
    uae: '/UAE.png',
    pakistan: '/Pakistan.png',
    india: '/India.png',
    china: '/China.png',
    kenya: '/Kenya.png'
  }
};

// Function to get image URL
export const getImageUrl = (path) => {
  return `${window.location.origin}${path}`;
}; 